// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { userMixins } from '@/app/mixins/modules/user-mixins.js';

// Third Party libraries
import * as $ from 'jquery';

// Services
import PuppySellService from '@/app/services/main/puppy-sell/puppy-sell-service.js';

// Constants
import { STATUS_CODES, SUCCESS_MSG, ERROR_MSG } from '@/app/constants/status-constants';

export default {
    name: 'DeletePuppyToSellModal',
    mixins: [
        toastMessageMixins,
        userMixins
    ],
    props: {
        puppySellId: {
          type: Number,
          required: true
        }
    },
    data() {
        return {
            isAPILoading: false,
            product: null
        }
    },
    mounted() {
        $(this.$refs.modalDeletePuppyToSell).on('hide.bs.modal', this.handleHideEvent);
    },
    beforeDestroy() {
        this.closeModal();
        $(this.$refs.modalDeletePuppyToSell).off('hide.bs.modal', this.handleHideEvent);
    },
    methods: {
        openModal() {
            $(this.$refs.modalDeletePuppyToSell).modal('show');
        },
        closeModal() {
            $(this.$refs.modalDeletePuppyToSell).modal('hide');
        },
        async deletePuppyToSell() {
            // TODO: Integration for delete puppy on sell list
            try {
                this.isAPILoading = true;
                const response = await PuppySellService.putDeletePuppyToSell(this.puppySellId)
                if (response.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
                    $(this.$refs.modalDeletePuppyToSell).modal('hide');
                    this.$emit('deleted', this.puppySellId);
                    this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, `Puppy has been successfully deleted from the Puppy List!`);
                    this.isAPILoading = false;
                } else {
                    this.showAPIErrorToast(ERROR_MSG.INTERNAL_ERROR_TITLE, response)
                    this.isAPILoading = false;
                }
            } catch (error) {
                this.showGenericErrorToast();
                this.isAPILoading = false;
            }
        }
    },
}